import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

const ScheduleAbsenceForm = ({ employeeId, date, absence, absenceTypes, supervisors, onSave, onDelete, onCancel, saving }) => {
  const [form, setForm] = useState({
    absenceTypeId: "",
    dateFrom: date,
    dateTo: date,
    comments: "",
    supervisorID: ""
  });

  useEffect(() => {
    setForm({
      absenceTypeId: absence?.absenceType?.id == null ? "" : String(absence.absenceType.id),
      dateFrom: absence?.dateFrom ?? date,
      dateTo: absence?.dateTo ?? date,
      comments: absence?.comments ?? "",
      supervisorID: absence?.supervisorID == null ? "" : String(absence.supervisorID)
    });
  }, [absence, date]);

  const submit = async event => {
    event.preventDefault();
    const saved = await onSave(absence, {
      EID: Number(employeeId),
      absenceType: { id: Number(form.absenceTypeId) },
      dateFrom: form.dateFrom,
      dateTo: form.dateTo,
      comments: form.comments,
      supervisorID: Number(form.supervisorID)
    });
    if (saved) onCancel();
  };

  const remove = async () => {
    if (!absence?.id) return;
    const removed = await onDelete(absence.id);
    if (removed) onCancel();
  };

  return (
    <Form onSubmit={submit} className="schedule-quick-form">
      <Form.Group>
        <Form.Label>Typ nieobecności</Form.Label>
        <Form.Select value={form.absenceTypeId} onChange={event => setForm(current => ({ ...current, absenceTypeId: event.target.value }))} required>
          <option value="">Wybierz typ</option>
          {(absenceTypes ?? []).map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
        </Form.Select>
      </Form.Group>
      <div className="schedule-quick-form-times">
        <Form.Group>
          <Form.Label>Od</Form.Label>
          <Form.Control type="date" value={form.dateFrom} onChange={event => setForm(current => ({ ...current, dateFrom: event.target.value }))} required />
        </Form.Group>
        <Form.Group>
          <Form.Label>Do</Form.Label>
          <Form.Control type="date" min={form.dateFrom} value={form.dateTo} onChange={event => setForm(current => ({ ...current, dateTo: event.target.value }))} required />
        </Form.Group>
      </div>
      <Form.Group>
        <Form.Label>Osoba zatwierdzająca</Form.Label>
        <Form.Select value={form.supervisorID} onChange={event => setForm(current => ({ ...current, supervisorID: event.target.value }))} required>
          <option value="">Wybierz osobę</option>
          {(supervisors ?? []).map(supervisor => <option key={supervisor.id} value={supervisor.id}>{supervisor.fullName}</option>)}
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Uwagi</Form.Label>
        <Form.Control as="textarea" rows={2} value={form.comments} onChange={event => setForm(current => ({ ...current, comments: event.target.value }))} />
      </Form.Group>
      <div className="schedule-form-actions mt-3">
        <Button type="submit" variant="primary" disabled={saving}>{absence ? "Zapisz" : "Dodaj"}</Button>
        {absence?.id && <Button type="button" variant="outline-danger" onClick={remove} disabled={saving}>Usuń</Button>}
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>Anuluj</Button>
      </div>
    </Form>
  );
};

export default ScheduleAbsenceForm;
